module.exports = __webpack_public_path__ + "img/tab_bkg.545c4017.png";